import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Cards } from 'inside-out/components/shared/cards';
import { GetInvolved } from 'inside-out/components/shared/getInvolved';
import { CommonPageHeader } from 'inside-out/components/about-us/commonPageHeader';

import TransformationIcon from 'inside-out/images/transformation-icon.svg';
import TieIcon from 'inside-out/images/tie-icon.svg';
import StarIcon from 'inside-out/images/star-icon.svg';
import BadgeIcon from 'inside-out/images/badge-icon.svg';
import EqualsIcon from 'inside-out/images/equals-icon.svg';
import CircleUnderlineIcon from 'inside-out/images/circle-underline-icon.svg';
import CircleOverlineIcon from 'inside-out/images/circle-overline-icon.svg';
import PlusIcon from 'inside-out/images/plus-icon.svg';

import {
	wrapperStyle,
	innerWrapperStyle,
	quadrantsWrapperStyle,
	ourKeyPillarsStyle,
	ourKeyPillarsInnerStyle,
	ourKeyPillarsTitleStyle,
	ourKeyPillarsCardStyle,
	titleStyle,
	bodyTextStyle,
	subTitleStyle,
	missionTextStyle,
} from 'inside-out/page-styles/about-us';

import {
	tabletLandscapeMaxWidthBreakpoint,
	mobileMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export default class AboutUsPage extends React.PureComponent {
	static propTypes = {
		data: PropTypes.shape({
			allContentJson: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							heading: PropTypes.string,
							body: PropTypes.string,
							content_heading_1: PropTypes.string,
							content_body_1: PropTypes.string,
							content_heading_2: PropTypes.string,
							content_body_2: PropTypes.string,
							content_heading_3: PropTypes.string,
							content_body_3: PropTypes.string,
							content_heading_4: PropTypes.string,
							content_body_4: PropTypes.string,
							our_mission_heading: PropTypes.string,
							our_mission_body: PropTypes.string,
							key_pillars_heading: PropTypes.string,
							key_pillars_tile_1_heading: PropTypes.string,
							key_pillars_tile_1_body: PropTypes.string,
							key_pillars_tile_2_heading: PropTypes.string,
							key_pillars_tile_2_body: PropTypes.string,
							key_pillars_tile_3_heading: PropTypes.string,
							key_pillars_tile_3_body: PropTypes.string,
							key_pillars_tile_4_heading: PropTypes.string,
							key_pillars_tile_4_body: PropTypes.string,
							our_history_heading: PropTypes.string,
							our_history_body: PropTypes.string,
						}),
					})
				),
			}),
		}),
	};

	render() {
		const {
			heading,
			body,
			content_heading_1,
			content_body_1,
			content_heading_2,
			content_body_2,
			content_heading_3,
			content_body_3,
			content_heading_4,
			content_body_4,
			our_mission_heading,
			our_mission_body,
			key_pillars_heading,
			key_pillars_tile_1_heading,
			key_pillars_tile_1_body,
			key_pillars_tile_2_heading,
			key_pillars_tile_2_body,
			key_pillars_tile_3_heading,
			key_pillars_tile_3_body,
			key_pillars_tile_4_heading,
			key_pillars_tile_4_body,
			our_history_heading,
			our_history_body,
		} = this.props.data.allContentJson.edges[0].node;

		return (
			<div className={wrapperStyle}>
				<Helmet title={ heading }>
					<meta property="og:type" content="website"/>
			    <meta property="og:title" content={ heading }/>
			    <meta name="description" content="InsideOut is Australia’s national institute for research and clinical excellence in eating disorders. With resources, rigour and perseverance we aim to transform the treatment landscape for eating disorders in this country, and ultimately find a cure."/>
			    <meta property="og:description" content="InsideOut is Australia’s national institute for research and clinical excellence in eating disorders. With resources, rigour and perseverance we aim to transform the treatment landscape for eating disorders in this country, and ultimately find a cure."/>
				</Helmet>

				{CommonPageHeader}
				<section className={innerWrapperStyle}>
					<h1 className={titleStyle}>{heading}</h1>
					<div className={bodyTextStyle} dangerouslySetInnerHTML={{ __html: body }} />
				</section>
				<div className={quadrantsWrapperStyle}>
					<section>
						<img src={TransformationIcon} alt="" />
						<h1>{content_heading_1}</h1>
						<div className={bodyTextStyle} dangerouslySetInnerHTML={{ __html: content_body_1 }} />
					</section>
					<section>
						<img src={TieIcon} alt="" />
						<h1>{content_heading_2}</h1>
						<div className={bodyTextStyle} dangerouslySetInnerHTML={{ __html: content_body_2 }} />
					</section>
					<section>
						<img src={StarIcon} alt="" />
						<h1>{content_heading_3}</h1>
						<div className={bodyTextStyle} dangerouslySetInnerHTML={{ __html: content_body_3 }} />
					</section>
					<section>
						<img src={BadgeIcon} alt="" />
						<h1>{content_heading_4}</h1>
						<div className={bodyTextStyle} dangerouslySetInnerHTML={{ __html: content_body_4 }} />
					</section>
				</div>
				<section className={innerWrapperStyle}>
					<h2 className={subTitleStyle}>{our_mission_heading}</h2>
					<p className={missionTextStyle}>{our_mission_body}</p>
				</section>

				<section className={ourKeyPillarsStyle}>
					<div className={ourKeyPillarsInnerStyle}>
						<h1 className={ourKeyPillarsTitleStyle}>{key_pillars_heading}</h1>
						<Cards
							columns={4}
							scrollable={false}
							columnsAt={{
								[`max-width: ${mobileMaxWidthBreakpoint}`]: 1,
								[`max-width: ${tabletLandscapeMaxWidthBreakpoint}`]: 2,
							}}
						>
							<div className={ourKeyPillarsCardStyle} data-component="Card">
								<div>
									<img src={PlusIcon} alt="" />
								</div>
								<h2>{key_pillars_tile_1_heading}</h2>
								<div dangerouslySetInnerHTML={{ __html: key_pillars_tile_1_body }} />
							</div>
							<div className={ourKeyPillarsCardStyle} data-component="Card">
								<div>
									<img src={CircleOverlineIcon} alt="" />
								</div>
								<h2>{key_pillars_tile_2_heading}</h2>
								<div dangerouslySetInnerHTML={{ __html: key_pillars_tile_2_body }} />
							</div>
							<div className={ourKeyPillarsCardStyle} data-component="Card">
								<div>
									<img src={EqualsIcon} alt="" />
								</div>
								<h2>{key_pillars_tile_3_heading}</h2>
								<div dangerouslySetInnerHTML={{ __html: key_pillars_tile_3_body }} />
							</div>
							<div className={ourKeyPillarsCardStyle} data-component="Card">
								<div>
									<img src={CircleUnderlineIcon} alt="" />
								</div>
								<h2>{key_pillars_tile_4_heading}</h2>
								<div dangerouslySetInnerHTML={{ __html: key_pillars_tile_4_body }} />
							</div>
						</Cards>
					</div>
				</section>

				<section className={innerWrapperStyle}>
					<h1 className={titleStyle}>{our_history_heading}</h1>
					<div className={bodyTextStyle} dangerouslySetInnerHTML={{ __html: our_history_body }} />
				</section>

				<GetInvolved />
			</div>
		);
	}
}

export const query = graphql`
	query AboutUsPageQuery {
		allContentJson(filter: { id: { regex: "/content\\/about-us-page\\.json/" } }) {
			edges {
				node {
					heading
					body
					content_heading_1
					content_body_1
					content_heading_2
					content_body_2
					content_heading_3
					content_body_3
					content_heading_4
					content_body_4
					our_mission_heading
					our_mission_body
					key_pillars_heading
					key_pillars_tile_1_heading
					key_pillars_tile_1_body
					key_pillars_tile_2_heading
					key_pillars_tile_2_body
					key_pillars_tile_3_heading
					key_pillars_tile_3_body
					key_pillars_tile_4_heading
					key_pillars_tile_4_body
					our_history_heading
					our_history_body
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/about-us/index.js